import { upperFirst } from 'lodash'

import { SENDING_HASHABLE_FIELDS } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'array' }) ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options, { type: 'array' }),
        {
          props: {
            value: this.proxy,
            items: [
              {
                component: components.select,
                props: {
                  items: SENDING_HASHABLE_FIELDS,
                  multiple: true
                }
              }
            ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
